import React, { Component } from 'react';
import { Row, Col } from 'antd';
import styled from 'styled-components';
import moment from 'moment';

import { CustomTestCard, MainCard, CustomTable, IconButton, HistoryFilters, GreenCheckIcon, RedCrossIcon } from '../../common';
import { IRouter } from '../../../utils/Interfaces';
import { HistoryResultRowsDesign } from '../../constants/historyResultRowsDesign'
import { filterResults } from '../../common/FilterResults'

type State = {
    filters: {
        selectedTimeOption: string,
        date: any
    }
    selectedResult: any,
    testData: any
}

type Props = {
    router: IRouter,
    results: Array<any>,
    validTime: number,
    calculateNextStudy: (dateOfTest: any, validTime: number) => string,
}

class UniformityHistory extends Component<Props, State> {
    constructor(props: any) {
        super(props);
        
        this.state = {
            filters: {
                selectedTimeOption: 'all',
                date: null,
            },
            selectedResult: null,
            testData: null
        }
    }

    render() {
        if (!this.state.selectedResult && this.props.results.length > 0) {
            this.changeSelectedResult(this.props.results[0]);
        }
        
        const { results, validTime, calculateNextStudy } = this.props;
        const { selectedResult, testData } = this.state;

        return (
            <>
                <Row gutter={[24, 24]}>
                    <Col span={4}>
                        <GreyStyledRow justify="center">
                            <IconButton
                                onClick={this.handleChangeToNewTest}
                                label='Nowy test'
                            />
                        </GreyStyledRow>
                        <WhiteStyledRow justify="center">
                            <Col span={18}>
                                <HistoryFilters 
                                    filters={this.state.filters}
                                    onChange={this.handleFiltersChange}
                                    onFinish={this.handleFiltersSubmit}
                                />
                            </Col>
                            <Col span={18}>
                                <CustomTable
                                    columns={this.historyResultsColumns}
                                    data={filterResults(results, this.state.filters.selectedTimeOption, this.state.filters.date || null)}
                                    cursor='pointer'
                                    onRow={(record: any) => {
                                        return {
                                          onClick: () => this.changeSelectedResult(record)
                                        }
                                    }}
                                />
                            </Col>
                        </WhiteStyledRow>
                    </Col>
                    <Col span={20}>
                        <Row gutter={[24, 24]}>
                            <Col span={24}>
                                <CustomTestCard
                                    resultId={selectedResult && selectedResult.result.id}
                                    title='Jednorodność obrazu'
                                    performer={selectedResult ? `${selectedResult.user.firstName} ${selectedResult.user.lastName}` : null}
                                    date={selectedResult ? selectedResult.result.dateOfTest : null}
                                    expirationDate={selectedResult ? calculateNextStudy(selectedResult.result.dateOfTest, validTime) : null}
                                    result={selectedResult ? selectedResult.result.passed : null}
                                />
                            </Col>
                            <Col span={8}>
                                <MainCard title='Parametry wejściowe'>
                                    {testData && testData.settings && 
                                        <Row>
                                            <Col span={24}>Ilość ROI: <b>{testData.settings.ROINumber}</b></Col>
                                            <Col span={24}>Średnica: <b>{testData.settings.diameter}</b>cm</Col>
                                            <Col span={24}>Odległość od środka: <b>{testData.settings.distance}</b>cm</Col>
                                            <Col span={24}>Odniesienie kV: <b>{testData.settings.kV}</b></Col>
                                            <Col span={24}>Odchylenie kV: <b>{testData.settings.kVDeviation}</b>%</Col>
                                            <Col span={24}>Odniesienie mA: <b>{testData.settings.mA}</b></Col>
                                            <Col span={24}>Odchylenie mA: <b>{testData.settings.mADeviation}</b>%</Col>
                                        </Row>
                                    }
                                </MainCard>
                            </Col>
                            <Col span={16}>
                                <MainCard title='Wyniki pomiaru'>
                                    <Col span={16}>
                                        <CustomTable
                                            columns={this.resultColumns}
                                            data={testData && testData.results}
                                        />
                                    </Col>
                                </MainCard>
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </>
        );
    }
    
    handleChangeToNewTest = () => {
        this.props.router.history.push(this.props.router.location.pathname.replace(/[^/]*$/, 'perform-test'));
    }

    changeSelectedResult = (newResult: any) => {
        this.setState({
            selectedResult: newResult,
            testData: JSON.parse(newResult.result.testData)
        })
    }

    handleFiltersChange = (filterName: string, newValue: any) => {
        this.setState(prevState => {
            prevState.filters[filterName] = newValue;
            return prevState;
        })
    }

    handleFiltersSubmit = () => {
        alert('Filtrowanie!');
    }

    resultColumns = [
        {
            title: "Nazwa",
            dataIndex: "name",
            key: "name"
        },
        {
            title: "Pomiar",
            dataIndex: "measure",
            key: "measure",
            render: (measure: number) => measure && measure.toFixed(2)
        },
        {
            title: "Odniesienie",
            dataIndex: "reference",
            key: "reference",
            render: (reference: number) => reference && reference.toFixed(2)
        },
        {
            title: "Odchylenie",
            dataIndex: "deviation",
            key: "deviation"
        },
        {
            title: "Poprawny",
            dataIndex: "result",
            key: "result",
            render: (result: boolean) => result ? <GreenCheckIcon /> : <RedCrossIcon />
        },
    ]
    
    historyResultsColumns = [
        {
            title: 'WYNIKI HISTORYCZNE',
            dataIndex: 'date',
            key: 'date',
            render: (_: any, row: any) => {
                const { selectedResult } = this.state;
                return {
                  props: {
                    style: 
                        {
                            background: selectedResult && selectedResult.result.id === row.result.id ? HistoryResultRowsDesign.SELECTED_RESULT_BACKGROUND_COLOR : null, 
                            color: selectedResult && selectedResult.result.id === row.result.id ? HistoryResultRowsDesign.SELECTED_RESULT_TEXT_COLOR : null, 
                            borderLeft: row.result.passed ? HistoryResultRowsDesign.BORDER_LEFT_TEST_PASSED_COLOR : HistoryResultRowsDesign.BORDER_LEFT_TEST_NOT_PASSED_COLOR, 
                            textAlign: HistoryResultRowsDesign.TEXT_ALIGN }
                        },
                    children: moment(row.result.dateOfTest).format('YYYY-MM-DD HH:mm')
                };
            }
        }
    ]
}

const GreyStyledRow = styled(Row)`
    background: #F6F7F8;
    padding: 20px 0px 20px 0px;
`

const WhiteStyledRow = styled(Row)`
    background: #FFFFFF;
    padding: 20px 0px 20px 0px;
`

export default UniformityHistory;